import { useUserStore } from "store/User";
import HeaderAuthenticated from "./authenticated";
import HeaderUnauthenticated from "./unauthenticated";

const Header = () => {
  const user = useUserStore((state) => state.user);

  if (user) {
    return <HeaderAuthenticated />;
  }
  return <HeaderUnauthenticated />;
};

export default Header;
